import {FlexBox, FlexBoxProps} from '../FlexBox';
import React from 'react';
import {useCss} from 'react-use';
import classNames from 'classnames';
import styles from './index.module.scss';

interface EllipsisProps extends FlexBoxProps {
    lines: number;
}

export function Ellipsis({lines, className, ...props}: EllipsisProps) {
    const cssClass = useCss({
        WebkitLineClamp: String(lines),
    });

    return (
        <FlexBox
            className={classNames(styles.root, className, cssClass)}
            {...props}
        />
    );
}
